import clinic from '@/assets/img/users-cases/clinic.webp';
import clinicHow from '@/assets/img/users-cases/clinic-how.webp';
import clinicResult from '@/assets/img/users-cases/clinic-result.webp';

export default {
  slug: 'clinic',
  order: 8,
  title: '360 View Medical Clinic',
  subtitle: 'Clean 2D plans and realistic 3D clinic renderings',
  tags: ['clinicfloorplans', 'clinicinteriordesign'],

  images: {
    hero: clinic,
    aboutTop: clinicHow,
    aboutBottom: clinicResult,
  },

  howText:
    'We developed clinic floor plan, layouts for clinics, and interior design for clinic with 2D and 3D visualizations. Layouts consider patient flow, equipment placement, and ergonomic working zones.',

  resultText:
    'Developers and agencies get ready-made plans to present clinics to clients, create marketing materials, and speed up project approvals.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
